import firebase_app from './config';
import axios from 'axios';

import {
    getFirestore,
    doc,
    setDoc,
    Timestamp,
    addDoc,
    collection,
    getDocs,
    deleteDoc,
    getDoc, query, where,
} from 'firebase/firestore/lite';

export const orderService = {
    getOrdersByEmail,
    saveOrder, getNonConfirmedOrder,
    saveConfirmedPaymentInfo,
    getConfirmedOrders,
    getOrderAttempts, saveOrderStatuses,
    savePaymentInfo, saveExtraContentOrderToSheetsAxios, saveOrderToSheetsAxios,
    saveCoupon,
    logReq,
    saveOrdersToSheets,
    saveConfirmedOrder,
    getOrder,
    saveEmailToOrder,
    savePayPalOrder,
    saveSummarizedData,
    saveTranzilaRequestBody,
    saveExtraContentOrder,
    createWordpressUser,
    saveShippingInfo,
    sendShipmentRequest,
    saveTrackingNumber,
    // deleteOrder,
};

const db = getFirestore(firebase_app);

async function saveEmailToOrder(id: string) {
    const docRef = doc(db, 'orders', id);
    const confirmedDocRef = doc(db, 'confirmedOrders', id);
    try {
        await setDoc(docRef, {emailSent: true}, {merge: true});
        await setDoc(confirmedDocRef, {emailSent: true}, {merge: true});
        return {id: id, message: 'Saved successfully'};
    } catch (error) {
        return {message: 'Error updating'};
    }
}

async function getNonConfirmedOrder(id: string) {
    const docRef = doc(db, 'orders', id);
    const docSnap = await getDoc(docRef);
    if (docSnap.exists()) {
        return {message: 'Success', data: docSnap.data()};
    } else {
        return {message: 'Error', data: {}};
    }
}

async function getOrdersByEmail(email: string) {
    const ordersCollection = collection(db, 'confirmedOrders');
    const q = query(ordersCollection, where('shippingInfo.email', '==', email));
    const querySnapshot = await getDocs(q);

    const orders: any[] = [];
    debugger;
    querySnapshot.forEach((doc) => {
        orders.push(doc.data());
    });

    return orders;
}

async function getOrder(id: string) {
    const docRef = doc(db, 'confirmedOrders', id);
    const docSnap = await getDoc(docRef);
    if (docSnap.exists()) {
        return {message: 'Success', data: docSnap.data()};
    } else {
        return {message: 'Error', data: {}};
    }
}

async function saveOrder(data: any, id: string = '') {
    const {
        shippingInfo,
        orderInfo,
        coupon,
        analyticsInfo,
        subscriptionConsent,
    } = data;
    if (!id) {
        const collectionRef = collection(db, 'orders');
        try {
            const docRef = await addDoc(collectionRef, {
                shippingInfo,
                orderInfo,
                coupon: coupon ?? {},
                analyticsInfo,
                orderCreatedAt: Timestamp.fromDate(new Date()),
                subscriptionConsent,
            });
            const docId = docRef.id;

            return {id: docId, message: 'Added successfully'};
        } catch (error) {
            return {message: 'Error saving error'};
        }
    } else {
        const docRef = doc(db, 'orders', id);

        try {
            await setDoc(
                docRef,
                {shippingInfo, orderInfo, coupon, analyticsInfo},
                {merge: true}
            );
            return {id: id, message: 'Saved successfully'};
        } catch (error) {
            return {message: 'Error updating'};
        }
    }
}

async function saveCoupon(coupon: any, id: string = '') {
    const docRef = doc(db, 'orders', id);
    try {
        await setDoc(docRef, {coupon}, {merge: true});
        return {id: id, message: 'Saved successfully'};
    } catch (error) {
        return {message: 'Error updating'};
    }
}

async function savePaymentInfo(data: any, id: string) {
    const docRef = doc(db, 'orders', id);
    const purchaseDate = Timestamp.fromDate(new Date());
    const {paymentStatus, paymentInfo} = data;
    const obj = {
        purchaseDate,
        paymentStatus,
        paymentInfo,
    };

    try {
        if (paymentStatus === 'confirmed') {
            //get doc data
            const docSnap = await getDoc(docRef);
            let docData = docSnap.data();
            if (docData) {
                docData['orderId'] = id;
                docData['id'] = id;
            }
            const newData = {...docData, ...obj};
            const confirmedDocRef = doc(db, 'confirmedOrders', id);
            await setDoc(confirmedDocRef, newData, {merge: true});
        }
        await setDoc(docRef, obj, {merge: true});
        const docSnap = await getDoc(docRef);
        const docData = docSnap.data();
        return {message: 'Success', data: docData};
    } catch (error) {
        return {message: 'Error', data: error};
        // throw error;
    }
}

async function saveConfirmedOrder(data: any, id: string) {
    //set doc
    const docRef = doc(db, 'confirmedOrders', id);
    await setDoc(docRef, data, {merge: true});
}

async function saveConfirmedPaymentInfo(data: any, id: string) {
    const docRef = doc(db, 'orders', id);
    const purchaseDate = Timestamp.fromDate(new Date());

    const {paymentStatus, paymentInfo} = data;
    const obj = {
        purchaseDate,
        paymentStatus,
        paymentInfo,
    };
    try {
        //save old doc to new collection 'confirmedOrders'
        const confirmedOrdersRef = collection(db, 'confirmedOrders');
        const confirmedDocRef = await addDoc(confirmedOrdersRef, {
            shippingInfo: data.shippingInfo,
            orderInfo: data.orderInfo,
            purchaseDate,
            paymentStatus,
            paymentInfo,
            coupon: data.coupon ?? {isAvailable: false},
            analyticsInfo: data.analyticsInfo,
        });

        const confirmedDocId = confirmedDocRef.id;

        return {message: 'Success'};
    } catch (error) {
        console.log('error: ', error);

        return {message: 'Error'};
        // throw error;
    }
}

async function getOrderAttempts() {
    const collectionRef = collection(db, 'orders');
    const snapshot = await getDocs(collectionRef);
    const salesInfo = snapshot.docs.map((doc) => ({id: doc.id, ...doc.data()}));
    return salesInfo;
}

// async function deleteOrder(id: string) {
//   const docRef = doc(db, 'orders', id);
//   //delete document from firestore#
//   try {
//     await deleteDoc(docRef);
//     return { message: 'Success' };
//   } catch (error) {
//     return { message: 'Error' };
//   }
//     // throw error;

// }

async function saveShippingInfo(data: any, trackNumber: any, id: string) {
    const docRef = doc(db, 'orders', id);
    const confirmedDocRef = doc(db, 'confirmedOrders', id);
    const obj = {
        shippingInfo: data,
        trackNumber: trackNumber,
    };
    try {
        await setDoc(docRef, obj, {merge: true});
        await setDoc(confirmedDocRef, obj, {merge: true});
        const docSnap = await getDoc(docRef);
        const docData = docSnap.data();
        return {message: 'Success', data: docData};
    } catch (error) {
        return {message: 'Error', data: error};
        // throw error;
    }
}

async function getConfirmedOrders() {
    const collectionRef = collection(db, 'confirmedOrders');
    const snapshot = await getDocs(collectionRef);
    return snapshot.docs.map((doc) => ({id: doc.id, ...doc.data()}));
}

function logReq(req: any) {
    // console.log("req: ", req);
    console.log('req.body: ', req.body);
    console.log('req.headers: ', req.headers);
}

async function savePayPalOrder(data: any, id: string) {
    const docRef = doc(db, 'orders', id);
    const confirmedDocRef = doc(db, 'confirmedOrders', id);
    try {
        await setDoc(docRef, {...data}, {merge: true});
        await setDoc(confirmedDocRef, {...data}, {merge: true});
    } catch (error) {
        console.log('error: ', error);
    }
}

async function saveOrdersToSheets() {
    const res = await fetch('/api/google/backup', {
        method: 'POST', // or 'GET', depending on how you've set up your API endpoint
        headers: {
            'Content-Type': 'application/json',
        },
        // body: JSON.stringify({ /* any data you want to send to the server */ })
    })
        .then((response) => response.json())
        .then((data) => console.log(data))
        .catch((error) => {
            console.error('Error:', error);
        });
}

async function saveOrderToSheetsAxios() {
    try {
        const response = await axios.post('/api/google/backup', {
            headers: {
                'Content-Type': 'application/json',
            },
            // data: { /* any data you want to send to the server */ }
        });

        console.log(response.data);
        return response.data;
    } catch (error) {
        console.error('Error:', error);
        throw error;
    }
}

async function saveExtraContentOrderToSheetsAxios() {
    try {
        const response = await axios.post('/api/google/extra-content', {
            headers: {
                'Content-Type': 'application/json',
            },
            // data: { /* any data you want to send to the server */ }
        });

        console.log(response.data);
        return response.data;
    } catch (error) {
        console.error('Error:', error);
        throw error;
    }
}

async function saveExtraContentOrder() {
    const res = await fetch('/api/google/extra-content', {
        method: 'POST', // or 'GET', depending on how you've set up your API endpoint
        headers: {
            'Content-Type': 'application/json',
        },
        // body: JSON.stringify({ /* any data you want to send to the server */ })
    })
        .then((response) => response.json())
        .then((data) => console.log(data))
        .catch((error) => {
            console.error('Error:', error);
        });
}

async function saveSummarizedData() {
    const res = await fetch('/api/google/sum-backup', {
        method: 'POST', // or 'GET', depending on how you've set up your API endpoint
        headers: {
            'Content-Type': 'application/json',
        },
        // body: JSON.stringify({ /* any data you want to send to the server */ })
    })
        .then((response) => response.json())
        .then((data) => console.log(data))
        .catch((error) => {
            console.error('Error:', error);
        });
}

async function saveTranzilaRequestBody(body: string, id: string) {
    const docRef = doc(db, 'orderLogRequests', id);
    const createdAt = Timestamp.fromDate(new Date());
    await setDoc(docRef, {requestBody: body, createdAt}, {merge: true});
}

async function saveOrderStatuses(id: string, OrderStatus: any) {
    const docRef = doc(db, 'confirmedOrders', id);
    const updatedAt = Timestamp.fromDate(new Date());
    await setDoc(docRef, {OrderStatus, updatedAt}, {merge: true});
}

async function createWordpressUser(username: any, email: any, password: any) {
    const res = await fetch('/api/wordpress', {
        method: 'POST', // or 'GET', depending on how you've set up your API endpoint
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({username, email, password}),
    })
        // .then((response) => response.json())
        // .then((data) => console.log(data))

        .catch((error) => {
            console.error('Error:', error);
        });
}

async function sendShipmentRequest(data: any, id: string) {
    const res = await fetch('/api/cheetah', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({data: data, id: id}),
    });
    const jsonResponse = await res.json();
    const shipNumRand = jsonResponse.ship_num_rand;
    return shipNumRand;
}

async function saveTrackingNumber(trackNumber: any, id: string) {
    //save trackNumber to doc
    const docRef = doc(db, 'confirmedOrders', id);
    const obj = {
        trackNumber: trackNumber,
    };
    try {
        await setDoc(docRef, obj, {merge: true});
        const docSnap = await getDoc(docRef);
        const docData = docSnap.data();
        return {message: 'Success', data: docData};
    } catch (error) {
        return {message: 'Error', data: error};
        // throw error;
    }

}